module.exports = __webpack_public_path__ + "img/flight.9f772bf1.svg";